const CATEGORIES_LOAD = 'CATEGORIES_LOAD';
const CATEGORIES_LOAD_SUCCESS = 'CATEGORIES_LOAD_SUCCESS';
const CATEGORIES_LOAD_FAIL = 'CATEGORIES_LOAD_FAIL';

const CATEGORIES_CHANGE_STATUS = 'CATEGORIES_CHANGE_STATUS';
const CATEGORIES_CHANGE_ITEM_POSITION = 'CATEGORIES_CHANGE_ITEM_POSITION';
const CATEGORIES_CHANGE_ITEM_POSITION_SUCCESS = 'CATEGORIES_CHANGE_ITEM_POSITION_SUCCESS';
const CATEGORIES_CHANGE_ITEM_POSITION_FAIL = 'CATEGORIES_CHANGE_ITEM_POSITION_FAIL';

const CATEGORIES_CHANGE_POSITION = 'CATEGORIES_CHANGE_POSITION';
const CATEGORIES_CHANGE_POSITION_SUCCESS = 'CATEGORIES_CHANGE_POSITION_SUCCESS';
const CATEGORIES_CHANGE_POSITION_FAIL = 'CATEGORIES_CHANGE_POSITION_FAIL';

const CATEGORIES_NEW = 'CATEGORIES_NEW';
const CATEGORIES_NEW_SUCCESS = 'CATEGORIES_NEW_SUCCESS';
const CATEGORIES_NEW_FAIL = 'CATEGORIES_NEW_FAIL';

const CATEGORIES_EDIT = 'CATEGORIES_EDIT';
const CATEGORIES_EDIT_SUCCESS = 'CATEGORIES_EDIT_SUCCESS';
const CATEGORIES_EDIT_FAIL = 'CATEGORIES_EDIT_FAIL';

const CATEGORIES_MODAL_NEW = 'CATEGORIES_MODAL_NEW';
const CATEGORIES_MODAL_EDIT = 'CATEGORIES_MODAL_EDIT';

export const onCategoriesLoad = () => ({type: CATEGORIES_LOAD })
export const onCategoriesLoadSuccess = (data) => ({type: CATEGORIES_LOAD_SUCCESS, data })
export const onCategoriesLoadFail = (data) => ({type: CATEGORIES_LOAD_FAIL, data })

export const onCategoriesChangeStatus = (status) => ({type: CATEGORIES_CHANGE_STATUS, status })


export const onCategoriesChangePosition = (items) => ({type: CATEGORIES_CHANGE_POSITION, items })
export const onCategoriesChangePositionSuccess = () => ({type: CATEGORIES_CHANGE_POSITION_SUCCESS })
export const onCategoriesChangePositionFail = () => ({type: CATEGORIES_CHANGE_POSITION_FAIL })

export const onCategoriesChangeItemPosition = (items) => ({type: CATEGORIES_CHANGE_ITEM_POSITION, items })
export const onCategoriesChangeItemPositionSuccess = () => ({type: CATEGORIES_CHANGE_ITEM_POSITION_SUCCESS })
export const onCategoriesChangeItemPositionFail = () => ({type: CATEGORIES_CHANGE_ITEM_POSITION_FAIL })
export const onCategoriesNew = (name) => ({type: CATEGORIES_NEW, name })
export const onCategoriesNewSuccess = (response) => ({type: CATEGORIES_NEW_SUCCESS, response })
export const onCategoriesNewFail = () => ({type: CATEGORIES_NEW_FAIL })
export const onCategoriesEdit = (category, archived = null) => ({type: CATEGORIES_EDIT, category, archived })
export const onCategoriesEditSuccess = (response) => ({type: CATEGORIES_EDIT_SUCCESS, response })
export const onCategoriesEditFail = (e) => ({type: CATEGORIES_EDIT_FAIL, e })

export const onCategoriesModalNew = (show) => ({type: CATEGORIES_MODAL_NEW, show })
export const onCategoriesModalEdit = (show) => ({type: CATEGORIES_MODAL_EDIT, show })

